import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2d6706f8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "recommended-action-card",
  role: "group",
  "aria-label": "Recommended Action"
}
const _hoisted_2 = ["aria-label", "innerHTML"]

import Button from 'primevue/button'
import { RecommendedAction } from '@/entities/frontlineManagerDash'
import { faClose } from 'fontawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from 'fontawesome/vue-fontawesome'
import { unescapeHTML } from '@/utils/string'

interface Props {
    action: RecommendedAction
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ActionCard',
  props: {
    action: {}
  },
  emits: ['dismissAction', 'triggerAction'],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit

const dismissAction = () => {
    emit('dismissAction')
}

const triggerAction = () => {
    emit('triggerAction')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", {
      class: "action-message",
      "aria-label": _unref(unescapeHTML)(_ctx.action.message),
      innerHTML: _ctx.action.message
    }, null, 8, _hoisted_2),
    _createElementVNode("button", {
      class: "action-close-button",
      "data-testid": "fm-dash-action-close-button",
      "aria-label": "Dismiss Action",
      onClick: dismissAction
    }, [
      _createVNode(_unref(FontAwesomeIcon), {
        icon: _unref(faClose),
        size: "xl"
      }, null, 8, ["icon"])
    ]),
    _createVNode(_unref(Button), {
      class: "action-trigger-button",
      "data-testid": "fm-dash-action-trigger-button",
      label: _ctx.action.label ?? _ctx.action.type,
      outlined: "",
      severity: "secondary",
      onClick: triggerAction
    }, null, 8, ["label"])
  ]))
}
}

})